import { useLingui } from '@lingui/react';
import { splitStringByLine } from '@wkda/funnel-utils';
import { QuestionsAccordion, useGetConsumerCarlead, useHandoverProps } from '@wkda/funnel-components';
import Button from '../Button';
import { getPriceStatus } from '../../../helpers/carlead';
import { scrollTo } from '../../../helpers/scrollTo';
import { jsx as _jsx } from "react/jsx-runtime";
const TRANSLATION_KEYS = {
  carlead: {
    question: 'carlead.faq.question',
    answer: 'carlead.faq.answer',
    cta: 'booking.faq.button.label'
  },
  selfeva: {
    title: 'selfInspection.faq.title',
    question: 'selfInspection.faq.question',
    answer: 'selfInspection.faq.answer',
    cta: 'selfInspection.faq.cta'
  },
  bookingValid: {
    title: 'booking.faq.title',
    question: 'booking.faq.valid.question',
    answer: 'booking.faq.valid.answer',
    cta: 'booking.faq.button.label'
  },
  bookingInvalid: {
    title: 'booking.faq.title',
    question: 'booking.faq.invalid.question',
    answer: 'booking.faq.invalid.answer',
    cta: 'booking.faq.button.label'
  }
};
const CTA_BUTTON_DATA = {
  className: 'btn btn-secondary btn-lg btn-arrow btn-gradient btn-shadow',
  action: 'goTop',
  dataLabel: 'CTA - Accordion'
};
const resolveTranslationKeys = (type, priceStatus) => {
  if (type === 'carlead') return TRANSLATION_KEYS.carlead;
  if (type === 'selfeva') return TRANSLATION_KEYS.selfeva;

  // type === 'booking'
  return priceStatus === 'reeva' ? TRANSLATION_KEYS.bookingInvalid : TRANSLATION_KEYS.bookingValid;
};
const buildQuestions = (questionsText, answersText) => {
  const answers = splitStringByLine(answersText).filter(Boolean);
  return splitStringByLine(questionsText).filter(Boolean).map((question, index) => ({
    question,
    answer: /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: answers[index]
      }
    })
  }));
};

/**
 * @param {object} props
 * @param {'booking' | 'carlead' | 'selfeva'} [props.type='booking']
 * @param {boolean} [props.headline=true]
 * @param {boolean} [props.cta=true]
 * @returns {JSX.Element}
 */
export const CollapsedFaq = ({
  type = 'booking',
  headline = true,
  cta = true
}) => {
  const {
    i18n
  } = useLingui();
  const priceStatus = getPriceStatus(useGetConsumerCarlead());
  const {
    isRiskFree
  } = useHandoverProps();
  const keys = resolveTranslationKeys(type, priceStatus);
  const questions = buildQuestions(i18n._(keys.question), i18n._(keys.answer));
  const containerClassName = `faq-accordion chevron-right ${isRiskFree ? 'risk-free' : 'balance-sheet'}`;
  const ctaButton = cta ? /*#__PURE__*/_jsx(Button, {
    data: {
      ...CTA_BUTTON_DATA,
      text: {
        full: i18n._(keys.cta)
      }
    },
    handleClick: () => scrollTo('body')
  }) : null;
  return /*#__PURE__*/_jsx(QuestionsAccordion, {
    className: containerClassName,
    "data-category": "FAQ",
    title: keys.title ? i18n._(keys.title) : null,
    renderTitle: headline,
    questions: questions,
    renderCta: ctaButton
  });
};